import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";

import Indicator from "./Indicator";

import "./_style.scss";

const LoadingCurtain = ({
  isLoading,
  children,
  loadingText = "Preparing your campaign",
}) => (
  <div
    data-testid="loading-curtain"
    className={
        classNames(
          "loading-curtain",
          {
            "--visible": isLoading,
          },
        )
      }
  >
    <div
      className={
          classNames(
            "loading-curtain__overlay",
            {
              "--visible": isLoading,
            },
          )
        }
    >
      <div
        className="loading-curtain__indicator"
        style={{
          margin: "0 auto",
          position: "relative",
          top: "100px",
        }}
      >
        <Indicator
          text={loadingText}
        />
      </div>
    </div>
    <div
      className={
          classNames(
            "loading-curtain__content",
            {
              "--blurred": isLoading,
            },
          )
        }
    >
      {!isLoading
          && children}
    </div>
  </div>
);

LoadingCurtain.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.node,
};

LoadingCurtain.defaultProps = {
  isLoading: false,
};

export default LoadingCurtain;
